export const SET_HEADER_TITLE = 'SET_HEADER_TITLE'
export const SET_HEADER_TITLE_ARRAY = 'SET_HEADER_TITLE_ARRAY'
export const OPEN_SIDE_NAV = 'OPEN_SIDE_NAV'
export const CLOSE_SIDE_NAV = 'CLOSE_SIDE_NAV'
export const SHOW_AUTH_POPUP = 'SHOW_AUTH_POPUP'
export const POPUP_APP_OPEN = 'POPUP_APP_OPEN'
export const CLOSE_BARCODE_SIDE_NAV = 'CLOSE_BARCODE_SIDE_NAV'
export const OPEN_BARCODE_SIDE_NAV = 'OPEN_BARCODE_SIDE_NAV'
